import  "./Article.css";

const Article = function (props) {
    return (
        <div className="articleWrap">
            <a className="articleImgLink"href={props.data.MODMuseumLink_Url} title={props.data.Title}>
                <img src={props.data.ModMuseumImg.ImageUrl} alt={props.data.Title} />
            </a>
            <div className="articleText">
                <a target="_blank" rel="noopener noreferrer" href={props.data.MODMuseumLink_Url} title={props.data.Title}>
                    <h3 className="articleTitle" dangerouslySetInnerHTML={{__html: props.data.Title}} />
                </a>
                <a target="_blank" rel="noopener noreferrer" href={props.data.MODNavLink_Url} title="קישור למפה">
                    <span className="articleDetails"  dangerouslySetInnerHTML={{__html: props.data.ModMuseumOpeningHours}} />
                </a>
                {(props.data.MODMuseumTicketsLink_Url) ?
                    <a className="TicketsLink" href={props.data.MODMuseumTicketsLink_Url} title="לקניית כרטיסים">
                        <img src="/_layouts/15/images/sites/Museums/Pages/Tickets.png" alt="לקניית כרטיסים" className="ticketsImg img-fluid"/>
                    </a>
                   : null} 
            </div>
        </div>
    );
}
    export default Article;